<div class="modal-header">
  <h4 class="modal-title d-block">Why do we charge to change details?</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()">
  </button>
</div>

<div class="modal-body">
  <div class="row mt-2">
    <div class="col-12">
      <p>
        Our primary role is animal welfare - an incredibly important
        service that we provide for over 4 Million pet keepers just
        like you. In fact the reason for charging a fee is to deliver
        this exact support .
      </p>
      <p>
        You may not be aware that the money you pay to
        microchip your pet is a fee to the vet for
        implanting the chip. We do not charge for your
        registration or for transferring details into your name if it
        was a breeder who is handing the pet over to you. We do not charge
        for storing these crucial details under strict DEFRA guidelines
        for the life of your pet. We do not charge you for 24/7 customer
        service - including over 20 staff in our York centre. We do not
        charge for the ‘always on’ tracking service that notifies you if
        your pet’s chip is scanned. We do not charge if you let us know
        your pet is missing and you want to mark this on our National database.
      </p>
      <p>
        Like all other database providers, there are costs associated with
        managing this service. For this reason we make a small charge.
        Most databases charge a one-off fee each time you make a change
        (think of it like buying a cinema ticket); Identibase encourages you
        to take out an ongoing Subscription that allows unlimited account
        changes and a bundle of other benefits (think Netflix); one provider
        does not charge a fee but offers you up for marketing to third
        party advertisers (think a paid commercial service like ITV).
      </p>
      <p>
        We hope this helps explain why we charge a small fee – we believe
        that £10 for a full year’s service is a small contribution to your
        pet’s overall and ongoing protection and do hope you will be able
        to remain with us over years of loving pet ownership to come.
      </p>
    </div>
  </div>
</div>
